<div class="aems-bread-crumb m-b-16">
  <!-- Users List -->
  <a class="m-r-4" routerLink="/users"> Users </a>

  <span class="m-r-4">/</span>

  <!-- Show only in EDIT mode -->
  @if (isEditMode) {
    <a class="m-r-4" [routerLink]="['/users', userId]"> User Details </a>
    <span class="m-r-4">/</span>
  }

  <!-- Current Page -->
  <span>
    {{ isEditMode ? 'Edit User' : 'Add User' }}
  </span>
</div>
<form [formGroup]="userForm">
  <div class="pure-g">
    <div class="page-header">
      <h2>{{ isEditMode ? 'Edit User' : 'Add User' }}</h2>
    </div>
    <div class="pure-u-md-24-24">
      <!-- ===================== ROW 1 ===================== -->
      <div class="user-row">
        <div class="pure-u-md-6-24 pure-u-lg-6-24 m-b-12 p-r-16 user-input">
          <mc-input
            ngDefaultControl
            formControlName="userName"
            label="User Name"
            placeholder="Enter user name"
            fit="small"
            [attr.invalid]="isControlInErrorState(userForm.get('userName'))">
            @if (userForm.controls['userName'].hasError('required')) {
              <span slot="errormessage">Required</span>
            }
            @if (userForm.controls['userName'].hasError('maxlength')) {
              <span slot="errormessage">Max Length should be 50</span>
            }
          </mc-input>
        </div>

        <div class="pure-u-md-6-24 pure-u-lg-6-24 m-b-12 p-r-16 user-input">
          <mc-input
            ngDefaultControl
            formControlName="firstName"
            label="First Name"
            placeholder="Enter first name"
            fit="small"
            [attr.invalid]="isControlInErrorState(userForm.get('firstName'))">
            @if (userForm.controls['firstName'].hasError('required')) {
              <span slot="errormessage">Required</span>
            }
            @if (userForm.controls['firstName'].hasError('maxlength')) {
              <span slot="errormessage">Max Length should be 30</span>
            }
          </mc-input>
        </div>

        <div class="pure-u-md-6-24 pure-u-lg-6-24 m-b-12 p-r-16 user-input">
          <mc-input
            ngDefaultControl
            formControlName="lastName"
            label="Last Name"
            placeholder="Enter last name"
            fit="small"
            [attr.invalid]="isControlInErrorState(userForm.get('lastName'))">
            @if (userForm.controls['lastName'].hasError('required')) {
              <span slot="errormessage">Required</span>
            }
            @if (userForm.controls['lastName'].hasError('maxlength')) {
              <span slot="errormessage">Max Length should be 30</span>
            }
          </mc-input>
        </div>
      </div>

      <!-- ===================== ROW 2 ===================== -->
      <div class="user-row">
        <div class="pure-u-md-6-24 pure-u-lg-6-24 m-b-12 p-r-16 user-input">
          <mc-input
            ngDefaultControl
            formControlName="emailAddress"
            label="Email Address"
            placeholder="Enter email address"
            fit="small"
            [attr.invalid]="isControlInErrorState(userForm.get('emailAddress'))">
            @if (userForm.controls['emailAddress'].hasError('required')) {
              <span slot="errormessage">Required</span>
            }
            @if (userForm.controls['emailAddress'].hasError('email')) {
              <span slot="errormessage">Incorrect Email Format</span>
            }
            @if (userForm.controls['emailAddress'].hasError('maxlength')) {
              <span slot="errormessage">Max Length should be 50</span>
            }
          </mc-input>
        </div>

        <div class="pure-u-md-6-24 pure-u-lg-6-24 m-b-12 p-r-16 user-input">
          <mc-input
            ngDefaultControl
            formControlName="companyName"
            label="Company Name"
            placeholder="Enter Company Name"
            fit="small"
            [attr.invalid]="isControlInErrorState(userForm.get('companyName'))">
            @if (userForm.controls['companyName'].hasError('required')) {
              <span slot="errormessage">Required</span>
            }
            @if (userForm.controls['companyName'].hasError('maxlength')) {
              <span slot="errormessage">Max Length should be 50</span>
            }
          </mc-input>
        </div>

        <div class="pure-u-md-6-24 pure-u-lg-6-24 m-b-12 p-r-16 user-input">
          <mc-input
            ngDefaultControl
            formControlName="locationCode"
            label="Location Code"
            placeholder="Enter location code"
            fit="small"
            [attr.invalid]="isControlInErrorState(userForm.get('locationCode'))">
            @if (userForm.controls['locationCode'].hasError('required')) {
              <span slot="errormessage">Required</span>
            }
            @if (userForm.controls['locationCode'].hasError('maxlength')) {
              <span slot="errormessage">Max Length should be 8</span>
            }
            @if (userForm.controls['locationCode'].hasError('pattern')) {
              <span slot="errormessage">Incorrect Format</span>
            }
          </mc-input>
        </div>
      </div>

      <!-- ===================== ROLE / REGION ===================== -->
      <div class="user-row">
        <div class="pure-u-md-12-12 p-b-16 p-r-16 user-input">
          <mc-select
            label="Role"
            fit="small"
            width="100"
            placeholder="Select Role"
            ngDefaultControl
            formControlName="role"
            [attr.invalid]="isControlInErrorState(userForm.get('role'))">
            @for (role of roleList; track role) {
              <mc-option [attr.data-cy]="role.description" [value]="role.description">
                {{ role.description }}
              </mc-option>
            }
          </mc-select>
        </div>

        @if (isShopRoleSelected) {
          <div class="pure-u-md-12-12 p-b-16 p-r-16 user-input">
            <app-aems-multiline-tag-input
              formControlName="shop"
              label="Shops"
              placeholder="Enter shop code(s)"
              [transformToUppercase]="true"
              [regex]="shopCodeRegex">
            </app-aems-multiline-tag-input>
            @if (userForm.controls['shop'].hasError('required') && submitted) {
              <span class="error-text">Required</span>
            }
          </div>
        }

        @if (!isShopRoleSelected && !isAdminRoleSelected) {
          <div class="pure-u-md-12-12 p-b-16 p-r-16 user-input">
            <mc-multi-select
              label="Regions"
              fit="small"
              width="100"
              placeholder="Select Regions"
              ngDefaultControl
              formControlName="region"
              [attr.invalid]="isControlInErrorState(userForm.get('region'))">
              @for (region of regions; track region) {
                <mc-option [attr.data-cy]="region.code" [value]="region.code">
                  {{ region.description }}
                </mc-option>
              }
              @if (userForm.controls['region'].hasError('required')) {
                <span slot="errormessage">Required</span>
              }
            </mc-multi-select>
          </div>
        }

        @if (!isShopRoleSelected && isAdminRoleSelected) {
          <div class="pure-u-md-12-12 p-b-16 p-r-16 user-input region-placeholder" aria-hidden="true"></div>
        }

        <div class="pure-u-md-4-24 pure-u-lg-2-24 p-b-16 p-r-8 m-t-28 user-input">
          <mc-checkbox fit="small" label="Is Active" [checked]="userForm.controls['isActive'].value" (change)="onActiveCheckChange($event)">
          </mc-checkbox>
        </div>
      </div>
    </div>

    <!-- ===================== BUTTONS ===================== -->
    <div class="pure-u-md-24-24 utility-buttons">
      <mc-button
        [label]="isEditMode ? 'Save Changes' : 'Add User'"
        slot="primaryAction"
        variant="filled"
        appearance="primary"
        fit="medium"
        class="p-r-16"
        (click)="onSubmit()"
        (keydown.enter)="onSubmit()"
        (keydown.space)="$event.preventDefault(); onSubmit()"
        tabindex="0"
        [disabled]="userForm.invalid || userForm.pristine">
      </mc-button>

      <app-button-with-confirmation
        label="Cancel"
        fit="medium"
        appearance="neutral"
        [modalBody]="
          isEditMode
            ? 'Are you sure you want to cancel editing this user? All unsaved changes will be lost permanently.'
            : 'Are you sure you want to cancel creating this user? All unsaved changes will be lost permanently.'
        "
        modalHeading="Unsaved Changes"
        confirmButtonLabel="Discard Changes"
        cancelButtonLabel="Keep Changes"
        [onConfirm]="onCancel()">
      </app-button-with-confirmation>
    </div>
  </div>
</form>
